import USPs from "components/USPs";
import { Link } from "react-router-dom";
import { brandConfig } from "../config/brandConfig";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";

export default function Home() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil" }]);
  }, [setItems]);

  return (
    <>
      <SEOMeta
        title="Accueil"
        description={`${brandConfig.brandName} est une marque française dédiée aux armoires à fusils sécurisées. Découvrez notre gamme grâce aux conseils de nos revendeurs experts et de notre réseau d’armuriers partenaires.`}
        canonicalPath="/"
      />
      {/* HERO */}
      <section className="hero">
        <div className="hero__inner container">
          {/* Colonne gauche : contenu sur fond blanc */}
          <div className="hero__content">
            <h1>Armoires à Fusils {brandConfig.brandName}</h1>
            <p className="hero__lead">
              Marque dédiée aux armoires à fusils sécurisées. Découvrez notre
              gamme grâce aux conseils de nos revendeurs experts et de notre
              réseau d’armuriers partenaires.
            </p>

            <div className="hero__cta">
              <Link
                to={brandConfig.mainCTA.path}
                className="btn"
                aria-label={`Voir la page ${brandConfig.mainCTA.label}`}
              >
                {brandConfig.mainCTA.label}
              </Link>
              <Link
                className="btn btn-secondary btn-ghost"
                to={brandConfig.becomeResellerCTA.path}
                aria-label={`Voir la page ${brandConfig.becomeResellerCTA.label}`}
              >
                {brandConfig.becomeResellerCTA.label}
              </Link>
            </div>

            <div className="hero__subcta">
              <Link
                className="btn btn-ghost"
                to={brandConfig.resellerCTA.path}
                aria-label={`Voir la page ${brandConfig.resellerCTA.label}`}
              >
                {brandConfig.resellerCTA.label}
              </Link>
            </div>
          </div>

          {/* Colonne droite : image produit */}
          <div className="hero__media" aria-hidden="true">
            <Link to={brandConfig.mainCTA.path}>
              <picture>
                <source
                  srcSet="/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-herobanner.webp"
                  type="image/webp"
                />
                <img
                  className="hero__product"
                  src="/assets/kaisersafe-hero.jpg"
                  alt=""
                  loading="eager"
                  decoding="async"
                  width={520}
                  height={520}
                />
              </picture>
            </Link>
          </div>
        </div>
      </section>

      {/* USPs */}
      <USPs />
    </>
  );
}
